const loadScript = (url, onLoad) => {
    const elem = document.createElement('script');
    elem.src = url;
    elem.async = true;
    elem.type = 'text/javascript';
    elem.onload = onLoad;
    const scpt = document.getElementsByTagName('script')[0];
    scpt.parentNode.insertBefore(elem, scpt);
};

export default loadScript;


// WEBPACK FOOTER //
// ./src/misc/utils/index.js